/* eslint-disable */
import {Style,Icon, Fill, Stroke,Circle as CircleStyle, Text} from 'ol/style.js';
import defaultIcon from '../assets/gisicon/map-marker.png'
import iconTaskDown from '../assets/gisicon/task_down.png'
import iconTaskUp from '../assets/gisicon/task_up.png'
import iconUser from '../assets/gisicon/user.png'

import iconUserHlZx from '../assets/gisicon/user_hl_zx.png'//护林员在线
import iconUserHlLx from '../assets/gisicon/user_hl_lx.png'//护林员离线
import iconUserLzZx from '../assets/gisicon/user_lz_zx.png'//林长在线
import iconUserLzLx from '../assets/gisicon/user_lz_lx.png'//林长离线
import iconUserQtZx from '../assets/gisicon/user_qt_zx.png'//其他在线
import iconUserQtLx from '../assets/gisicon/user_qt_lx.png'//其他离线

import iconUserHlZxSelected from '../assets/gisicon/user_hl_zx_selected.png'//护林员在线选中
import iconUserHlLxSelected from '../assets/gisicon/user_hl_lx_selected.png'//护林员离线选中
import iconUserLzZxSelected from '../assets/gisicon/user_lz_zx_selected.png'//林长在线选中
import iconUserLzLxSelected from '../assets/gisicon/user_lz_lx_selected.png'//林长离线选中
import iconUserQtZxSelected from '../assets/gisicon/user_qt_zx_selected.png'//其他在线选中
import iconUserQtLxSelected from '../assets/gisicon/user_qt_lx_selected.png'//其他离线选中

import iconBoardSelected from '../assets/gisicon/board_selected.png'
import iconSysDiscoverSelected from '../assets/gisicon/sys_discover_selected.png'
// import iconMonitorSelected from '../assets/gisicon/geo_monitor_selected.png'
import iconMonitorSelected from '../assets/gisicon/jkdSelected.png'
import iconGushuSelected from '../assets/gisicon/geo_gushu_selected.png'
import iconUserSelected from '../assets/gisicon/lz_user_selected.png'
import iconTaskSelected from '../assets/gisicon/lz_task_selected.png'
import defaultIconSelected from '../assets/gisicon/map-marker-selected.png'
import ggsfqsheng from '../assets/gisicon/ggsfq_sheng.png'
import ggsfqshi from '../assets/gisicon/ggsfq_shi.png'
import ggsfqxian from '../assets/gisicon/ggsfq_xian.png'
import ggsfqxiang from '../assets/gisicon/ggsfq_xiang.png'
import ggsfqcun from '../assets/gisicon/ggsfq_cun.png'
import ggsfqSelected from '../assets/gisicon/geo_demonstration_area.png'
import liaowangta from '../assets/gisicon/liaowangta.png'
import liaowangtaSelected from '../assets/gisicon/liaowangtaSel.png'

import boundarySelected from '../assets/gisicon/boundaryTip_selected.png'
import bjTask from '../assets/gisicon/yujing.png'
import bjTaskSelected from '../assets/gisicon/bjTaskSelected.png'
import bjedTask from '../assets/gisicon/bjedTask.png'
import bjedTaskSelected from '../assets/gisicon/bjedTaskSelected.png'
//WMS类型图层的图标在这里定义（仅需要设置选中样式的图标，默认显示样式在GeoServer中设置Style）
export const locateStyleCollection = {
    "default": new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: defaultIcon,
        anchor:[0.5,1]
      }))
    }),
    "lz_user_selected":new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: iconUserSelected
      }))
    }),
    "lz_task_selected":new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: iconTaskSelected
      }))
    }),
    "geo_gushu_selected":new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: iconGushuSelected
      }))
    }),
    "geo_board_selected":new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: iconBoardSelected
      }))
    }),
    "geo_monitor_selected":new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: iconMonitorSelected,
        scale: 0.6,
      }))
    }),
    "sys_discover_selected":new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: iconSysDiscoverSelected
      }))
    }),
    "geo_grid_sheng_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 3
      })
    }),
    "geo_grid_shi_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 3
      })
    }),
    "geo_grid_xian_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 3
      })
    }),
    "geo_grid_xiang_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 3
      })
    }),
    "geo_grid_cun_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 3
      })
    }),
    "geo_sheng_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 3
      })
    }),
    "geo_shi_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 3
      })
    }),
    "geo_xian_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 3
      })
    }),
    "geo_xiang_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 3
      })
    }),
    "geo_cun_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 3
      })
    }),
    "geo_xiaoban_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 1.5
      })
    }),
    "LAYER_TYPE_010_selected": new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 1.5
      })
    }),
    "geo_shidi_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 1.5
      })
    }),
    "geo_hongxian_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 1.5
      })
    }),
    "geo_baohudi_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 1.5
      })
    }),
    "lz_protect_forest_line_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 3.8
      })
    }),
    "lz_protect_forest_point_selected":new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: defaultIconSelected,
        anchor:[0.5,1]
      }))
    }),
    "geo_demonstration_area_selected":new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: ggsfqSelected
      }))
    }),
    "job_selected":new Style({
      stroke: new Stroke({
        color: '#2DFFFE',
        width: 1.5
      }),
      fill: new Fill({
        color: 'rgba(0, 0, 100, 0.2)'
      })
    }),
    'jobline_selected': new Style({
      stroke: new Stroke({
        color: '#ffd74b',
        lineDash:[1,2,3,4,5,6],
        width: 3
      })
    }),
    'locate_point':new Style({
      image: new CircleStyle({
        radius: 5,
        fill: new Fill({
          color: "rgba(255, 255, 254, 1)"
        })
      })
    }),
    "vs_video_device_selected": new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */({
        src: liaowangtaSelected,
        scale: 0.5
      }))
    }),
    'pestJkd_selected': new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */({
        src: iconMonitorSelected,
        scale: 0.6,
  
      }))
    }),
    "LAYER_TYPE_009_selected":new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: boundarySelected,
        scale:0.5
      }))
    }),
  }

  //WFS类型图层的图标在这里定义（选中样式也一起挪到locateStyleCollection中方便调用）
  export function wfsStyleFunction(feature){
    if(feature.getId().indexOf('lz_task') > -1){
      return taskStyle(feature)
    }else if(feature.getId().indexOf('v_lz') > -1){
      return userStyle(feature)
    }else if(feature.getId().indexOf('geo_demonstration_area') > -1){
      return ggsfqStyle(feature)
    }
  }

// 人员选中样式
export function renyuanStyleFunction(feature){
  var role=feature.getProperties().people_role;//角色zl林长，hly护林员，不是上面就是其他
  var online=feature.getProperties().online;//是否在线，false，是离线，true是在线
  let img='';
  if(online){//线上
    img=role=='zl'?iconUserLzZxSelected:role=='hly'?iconUserHlZxSelected:iconUserQtZxSelected
  }else{//离线
    img=role=='zl'?iconUserLzLxSelected:role=='hly'?iconUserHlLxSelected:iconUserQtLxSelected
  }
  return new Style({
    image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
      src: img,
      scale:0.07
    })),
    stroke: new Stroke({
      color: '#ff0000',
      width: 3
    })
  })
}
export function taskStyleFunction(feature) {
  let type = feature.getProperties().report_type;
  let status = feature.getProperties().status;
  let img = (type == 2 && (status == 'todo' || status == 'doing')) ? bjTaskSelected : (type == 2 && status != 'todo' && status != 'doing') ? bjedTaskSelected : iconTaskSelected;
  return new Style({
    image: new Icon(/** @type {module:ol/style/Icon~Options} */({
      src: img,
      scale: type == 2 ? 0.35 : 1
    })),
  })
}
  //为任务创建wfs样式
  function taskStyle(feature){
    var imgurl = null
    if(feature.getProperties().type == 'sb' || feature.getProperties().type == 'qzsb'){
      imgurl = iconTaskUp
    }else if(feature.getProperties().type == 'xf'){
      imgurl = iconTaskDown
    }
    return new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: imgurl
      }))
    })
  }

  //为人员创建wfs样式
  function userStyle(feature){
    var text = feature.getProperties().real_name || '';
    var role=feature.getProperties().people_role;//角色zl林长，hly护林员，不是上面就是其他
    var online=feature.getProperties().online;//是否在线，false，是离线，true是在线
    let img='';
    if(online){//线上
      img=role=='zl'?iconUserLzZx:role=='hly'?iconUserHlZx:iconUserQtZx
    }else{//离线
      img=role=='zl'?iconUserLzLx:role=='hly'?iconUserHlLx:iconUserQtLx
    }
    return new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: img,
        scale:0.07
      })),
      // text:new Text({
      //   text:text,
      //   font:'bold 14px serif',
      //   offsetY:22,
      //   fill:new Fill({
      //     color: 'rgba(255, 255, 255, 1)',
      //   }),
      // })
    })
  }

  //改革示范区wfs样式
  function ggsfqStyle(feature){
    var imgurl = null,
        zqlevel = feature.getProperties().zq_level, //[null,1,1,2,2,3,3,4,4,4,5,5,5,5,5][feature.getProperties().zq_code.length],
        text = feature.getProperties().type.substring(0,1)
    if(zqlevel == 1){
      imgurl = ggsfqsheng
    }else if(zqlevel == 2){
      imgurl = ggsfqshi
    }else if(zqlevel == 3){
      imgurl = ggsfqxian
    }else if(zqlevel == 4){
      imgurl = ggsfqxiang
    }else if(zqlevel == 5){
      imgurl = ggsfqcun
    }
    // console.log(feature.getProperties().type,feature.getProperties().zq_code)
    return new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */ ({
        src: imgurl
      })),
      text:new Text({
        text:text,
        font:'normal 14px serif',
        offsetY:-5,
        fill:new Fill({
          color: 'rgba(255, 255, 255, 1)',
        }),
      })
    })
  }
